module.exports = __webpack_public_path__ + "static/dteams-e2c1e23dcb8fd8d310520bfb1dec673a.jpg";